import { Box, Button, IButtonProps, Popover, PopoverArrow, PopoverContent, PopoverTrigger, Text } from "@govlaunch/web";
import { xor } from "lodash/fp";
import React from "react";
import { FormattedMessage } from "react-intl";
import { useToggle } from "react-use";

interface IMultipleFilterSelectOption {
  value: string;
  label: string;
}

interface IMultipleFilterSelectProps {
  buttonText: string;
  options: IMultipleFilterSelectOption[];
  selectedOptions: string[];
  onChange: (values: string[]) => void;
  isOpen?: boolean;
  onToggleOpen?: () => void;
}

export default function MultipleFilterSelect({
  buttonText,
  options,
  selectedOptions,
  onChange,
  isOpen: controlledIsOpen,
  onToggleOpen: controlledToggleOpen,
  ...props
}: IMultipleFilterSelectProps & Omit<IButtonProps, "onChange" | "children">) {
  const [uncontrolledIsOpen, uncontrolledToggleOpen] = useToggle(false);

  const isOpen = typeof controlledIsOpen !== "undefined" ? controlledIsOpen : uncontrolledIsOpen;
  const toggleOpen = typeof controlledToggleOpen !== "undefined" ? controlledToggleOpen : uncontrolledToggleOpen;

  return (
    <Popover placement="bottom-end" isOpen={isOpen}>
      <PopoverTrigger>
        <Button
          size="sm"
          variant="outline"
          bg="white"
          flex={1}
          variantColor="gray.900"
          rightIcon={props => (
            <svg width="14" height="6" viewBox="0 0 14 6" fill="none" {...props}>
              <path d="M7 6L0.0717959 1.30507e-06L13.9282 9.36995e-08L7 6Z" fill="#272E38" />
            </svg>
          )}
          {...props}
          onClick={toggleOpen}
        >
          {buttonText}
        </Button>
      </PopoverTrigger>
      <PopoverArrow />
      <PopoverContent maxWidth="220px" zIndex={100}>
        <Box overflow="hidden" borderRadius="md" border="1px" borderColor="gray.900" bg="white">
          <Box>
            {options.map(option => (
              <Box
                key={option.value}
                as="label"
                display="flex"
                alignItems="center"
                pt={2}
                pl={4}
                pr={4}
                pb={2}
                _hover={{
                  bg: "blue.100",
                }}
              >
                <input
                  type="checkbox"
                  checked={selectedOptions.includes(option.value)}
                  onChange={() => onChange(xor([option.value], selectedOptions))}
                />
                <Text fontSize="sm" color="black" ml={3}>
                  {option.label}
                </Text>
              </Box>
            ))}
          </Box>
          <Box display="flex" justifyContent="flex-end" pb={2} pr={3} pt={2}>
            <Button size="xs" variant="primary" minWidth="85px" onClick={toggleOpen}>
              <FormattedMessage defaultMessage="Done" id="JXdbo8" />
            </Button>
          </Box>
        </Box>
      </PopoverContent>
    </Popover>
  );
}
